/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, folder: NonNullable<unknown> }} Toast_Added_Files_To_FolderInputs */

const en_toast_added_files_to_folder = /** @type {(inputs: Toast_Added_Files_To_FolderInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Added ${i?.count} file to ${i?.folder}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Added ${i?.count} files to ${i?.folder}`);
	return /** @type {LocalizedString} */ ("toast_added_files_to_folder");
};

const es_toast_added_files_to_folder = /** @type {(inputs: Toast_Added_Files_To_FolderInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Se agregó ${i?.count} archivo a ${i?.folder}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Se agregaron ${i?.count} archivos a ${i?.folder}`);
	return /** @type {LocalizedString} */ ("toast_added_files_to_folder");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Added {count} file to {folder}" |
* | "other" | "Added {count} files to {folder}" |
*
* @param {Toast_Added_Files_To_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_added_files_to_folder = /** @type {((inputs: Toast_Added_Files_To_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Added_Files_To_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_added_files_to_folder(inputs)
	return en_toast_added_files_to_folder(inputs)
});